/* @flow */
import { isEqual } from 'lodash';
import React from 'react';

import AddButton from 'components/AddButton.jsx';
import AffiliationStore from 'stores/AffiliationStore';
import Columns2 from 'components/Columns2.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Glyph from 'components/Glyph.jsx';
import Groups from 'collections/Groups';
import GroupStore from 'groups/stores/GroupStore';
import Legend from 'components/Legend.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import Organization from 'entities/Organization';
import OrganizationActions from 'actions/OrganizationActions';
import OrganizationStore from 'stores/OrganizationStore';
import SchoolPicker from 'components/SchoolPicker.jsx';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';
import { OrganizationTypes } from 'constants/OrganizationConstants';

import SettingsContainer from './SettingsContainer.jsx';
import SettingsSchoolsListItem from './SettingsSchoolsListItem.jsx';

import './styles/UserSchoolsForm.scss';

type State = {
  isEditing: boolean,
  addingId: ?number,
  schools: Array<Organization>,
  groups: Groups,
};

const UserSchoolsForm = React.createClass({
  childContextTypes: {
    eventScreenName: React.PropTypes.string,
  },

  mixins: [
    linkStateWithStores([
      OrganizationStore,
      AffiliationStore,
      GroupStore,
    ]),
  ],

  getInitialState(): State {
    return {
      isEditing: false,
      addingId: null,
      schools: AffiliationStore.getMemberOrganizations(),
      groups: GroupStore.getGroups(),
    };
  },

  getChildContext() {
    return {
      eventScreenName: 'SettingsSchool',
    };
  },

  // OrganizationStores fire lots of emitChange during search
  shouldComponentUpdate(nextProps: Object, nextState: State) {
    const same = nextState.schools.length === this.state.schools.length
      && nextState.groups.length === this.state.groups.length
      && isEqual(nextState.addingId, this.state.addingId)
      && isEqual(nextState.isEditing, this.state.isEditing);
    return !this.state.isEditing || !same;
  },

  componentDidUpdate(prevProps: Object, prevState: State) {
    if (this.state.isEditing && !prevState.isEditing) {
      this.refs.schoolPicker.focus();
    }
  },

  onSelectSchool(schoolId: number) {
    this.setState({ isEditing: false, addingId: schoolId });
    const schoolIds = this.state.schools.map(s => s.id);
    schoolIds.push(schoolId);
    UserActions.update({ organization_ids: schoolIds }).then(this.onAddSuccess, this.onAddError);
  },

  onAddSuccess() {
    OrganizationActions.loadUserOrganizations();
    // $FlowFixMe
    OrganizationActions.getOrLoadOrganization(this.state.addingId).then(school => {
      ToastActions.showSuccessToast(`You joined ${school.getName()}`);
    }).catch(e => console.error('UserSchoolsForm failed to get or load organization', e));
    this.setState({ addingId: null });
  },

  onAddError() {
    ToastActions.showDefaultErrorToast();
    this.setState({ addingId: null });
  },

  getStateFromStores() {
    return {
      schools: AffiliationStore.getMemberOrganizations(),
      groups: GroupStore.getGroups(),
    };
  },

  filterSearchResults(orgs: Array<Organization>) {
    return orgs.filter(org => {
      return !this.state.schools.some(s => s.id === org.id);
    });
  },

  renderAddSchool() {
    const addSchool = this.state.isEditing ?
      <SchoolPicker
        className="UserSchoolsForm-schoolPicker"
        organizationType={OrganizationTypes.SCHOOL}
        filterSearchResults={this.filterSearchResults}
        onSelect={this.onSelectSchool}
        onClear={() => {}}
        onCreateOrganization={school => this.onSelectSchool(school.id)}
        onBlur={() => { this.setState({ isEditing: false }); }}
        noQuery="Search for a school"
        ref="schoolPicker"
      /> :
      <AddButton
        size="large"
        onClick={() => { this.setState({ isEditing: true }); }}>
        Join a school
      </AddButton>;

    return (
      <div className="UserSchoolsForm-addSchool">
        {addSchool}
      </div>
    );
  },

  renderSchoolRow(submitting: boolean, school: Organization) {
    return (
      <SettingsSchoolsListItem
        key={school.id}
        school={school}
        affiliation={AffiliationStore.getAffiliation(school.id)}
        groups={this.state.groups.filter(g =>
          g.getOrganization() && g.getOrganization().id === school.id && !g.isStaffClass()
        )}
        submitting={submitting}
      />
    );
  },

  // quick fix for `.bind` in render
  renderSchoolRowNotSubmitting(school: Organization) {
    return this.renderSchoolRow(false, school);
  },

  render() {
    return (
      <div className="UserSchoolsForm">
        <Fieldset>
          <Legend>
            {this.state.schools.length > 1 ? 'Schools' : 'School'}
          </Legend>
          <SettingsContainer>
            <div className="UserSchoolsForm-schoolList">
              {this.state.schools.map(this.renderSchoolRowNotSubmitting)}
              {this.state.addingId &&
                this.renderSchoolRow(true, OrganizationStore.getOrganization(this.state.addingId))}
            </div>
            <Columns2>
              {!this.state.addingId && this.renderAddSchool()}
              {this.state.isEditing &&
                <Glyph className="UserSchoolsForm-closeButton" name="close" size="large" />}
            </Columns2>
          </SettingsContainer>
        </Fieldset>
      </div>
    );
  },

});

export default UserSchoolsForm;



// WEBPACK FOOTER //
// ./src/settings/components/UserSchoolsForm.jsx